import React from 'react';

export function Button({ children, className = '', disabled, onClick, ...props }) {
  return (
    <button
      className={`px-4 py-2 rounded-md text-white font-medium transition-colors ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}